import React, { FC } from "react";

export const CalculatorIntro: FC = () => (
  <div className="flex flex-col items-start justify-center gap-5 text-green-base lg:gap-7">
    <h1 className="text-28 font-montserrat font-black md:text-40 lg:text-64">
      Калькулятор вартості
    </h1>
    <p className="text-xs md:text-base">
      Розрахуйте вартість індивідуального супроводу згідно
      організаційно-правової форми, системи оподаткування та кількості операцій
      у місяць
    </p>
  </div>
);
